export interface CalendarDay {
  date: Date
  isCurrentMonth: boolean
  isDisabled: boolean
}

export const createStartOfDay = (date: Date) => {
  const nextDate = new Date(date)
  nextDate.setHours(0, 0, 0, 0)
  return nextDate
}

export const createDateTime = (
  date: Date,
  hours: number,
  minutes: number,
) => {
  const nextDate = createStartOfDay(date)
  nextDate.setHours(hours, minutes, 0, 0)
  return nextDate
}

export const createMonthStart = (date: Date) => {
  const nextDate = createStartOfDay(date)
  nextDate.setDate(1)
  return nextDate
}

export const addMonths = (date: Date, monthOffset: number) => {
  const nextDate = createMonthStart(date)
  nextDate.setMonth(nextDate.getMonth() + monthOffset)
  return nextDate
}

export const createMaxDate = (date: Date) => {
  const nextDate = createStartOfDay(date)
  nextDate.setFullYear(nextDate.getFullYear() + 1)
  return nextDate
}

export const isSameDay = (firstDate: Date, secondDate: Date) => {
  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  )
}

export const buildCalendarDays = (
  visibleMonth: Date,
  minimumDate?: Date,
  maximumDate?: Date,
) => {
  const monthStart = createMonthStart(visibleMonth)
  const monthWeekday = (monthStart.getDay() + 6) % 7
  const gridStart = new Date(monthStart)
  gridStart.setDate(gridStart.getDate() - monthWeekday)

  return Array.from({ length: 42 }, (_, index) => {
    const cellDate = new Date(gridStart)
    cellDate.setDate(gridStart.getDate() + index)
    const normalizedDate = createStartOfDay(cellDate)

    return {
      date: normalizedDate,
      isCurrentMonth: normalizedDate.getMonth() === visibleMonth.getMonth(),
      isDisabled:
        (minimumDate !== undefined && normalizedDate < minimumDate) ||
        (maximumDate !== undefined && normalizedDate > maximumDate),
    } satisfies CalendarDay
  })
}
